// 사이트용 대학 허브 목록 — ops/local-univ-db 에서 sync
// 재생성: python scripts/local_univ_db.py sync-site
// 원본 편집: ops/local-univ-db/catalog.json (+ grant / sync)

import universityDb from './universityDb.json';

export const universityDbMeta = {
  version: universityDb.version,
  syncedAt: universityDb.syncedAt,
  source: universityDb.source,
  policy: universityDb.policy,
  count: universityDb.count,
};

/** @type {Array<{id:string,nameKo:string,nameJa:string,admissionUrl:string,notes:string,tags:string[],verifiedAt:string,permissionScope?:string}>} */
export const universityCatalog = universityDb.universities || [];

export function catalogById(id) {
  return universityCatalog.find((u) => u.id === id);
}

export function catalogForTag(tag) {
  return universityCatalog.filter((u) => u.tags?.includes(tag));
}

export function catalogGranted() {
  return universityCatalog;
}
